import { atom } from 'recoil'

import defaultImage from 'assets/svg/default-image-circle.svg'

export interface IUserProfile {
  profileFullName: string
  profileName: string
  profileId: string
  profileImage: string
}

export const userProfileState = atom({
  key: 'userProfile',
  default: {
    profileFullName: '',
    profileName: '',
    profileId: '',
    profileImage: defaultImage,
  },
})
